import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ChannelContainerModel} from "../../../../../../../models/aggregates/alg/cc/channel";

@Injectable({providedIn: 'root'})
export class ChannelService extends BaseApiTemplateService<ChannelContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "channels";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "channels";
    this.httpClient = http;
  }
}
